module.exports = __webpack_public_path__ + "static/media/tick.f5cbbba9.svg";